{
	"locale": "en-AU",
	"translations": {
		"activate-button-label": "Activate",
		"activate-button-progress-label": "Activating...",
		"activate-failed-label": "That code didn't work. Please try again, or register again.",
		"activate-heading-label": "Enter the code from your email",
		"activate-invalid-link-label": "This activation link is invalid.",
		"activate-register-link-label": "Back to Register",
		"applicant-interviews-date-label": "Date",
		"applicant-interviews-options-label": "Options",
		"applicant-interviews-status-label": "Status",
		"applicant-request-call-button-label": "Request Call",
		"applicant-request-call-button-progress-label": "Requesting, please wait...",
		"applicant-request-call-heading-label": "Complete",
		"applicant-request-call-label": "Thank you for completing the verification.  Please click the button below to receive a call and begin your interview.",
		"applicant-request-call-used-label": "Your interview will begin shortly.",
		"applicant-verification-button-label": "Verify",
		"applicant-view-interviews-label": "View Interviews",
		"applicant-verification-button-progress-label": "Verifying",
		"applicant-verification-heading-label": "Verification Code",
		"applicant-download-interview-label": "Download Interview",
		"applicants-email-label": "Email",
		"applicants-firstName-label": "First Name",
		"applicants-lastName-label": "Last Name",
		"applicants-options-label": "",
		"applicants-phoneNumber-label": "Phone Number",
		"business-logo-source": "/logos/logo_144x144.png",
		"business-name": "Schabu Pty Ltd.",
		"confirm-dialog-dismiss-label-default": "Cancel",
		"confirm-dialog-confirm-label-default": "Ok",
		"dashboard-latest-jobs-applicants-label": "Applicants",
		"dashboard-latest-jobs-company-label": "Company",
		"dashboard-latest-jobs-created-label": "Created",
		"dashboard-latest-jobs-heading-label": "Latest Jobs",
		"dashboard-latest-jobs-options-label": "",
		"dashboard-latest-jobs-published-label": "Published",
		"dashboard-latest-jobs-status-label": "Status",
		"dashboard-latest-jobs-title-label": "Title",
		"dashboard-trial-applicants-label": "Applicants",
		"dashboard-trial-banner-label": "Trial — awaiting approval",
		"dashboard-trial-interview-calls-label": "Interview Calls",
		"dashboard-trial-jobs-label": "Jobs",
		"directory-apply-button-label": "Apply Now!",
		"directory-apply-button-label-progress": "Please wait...",
		"forgot-password-button-label": "Reset Password",
		"forgot-password-button-progress-label": "Resetting...",
		"forgot-password-email-label": "Email",
		"forgot-password-email-placeholder": "Email",
		"forgot-password-login-link-label": "Login",
		"forgot-password-reset-heading-label": "Password Reset",
		"forgot-password-reset-label": "Password reset sent!  Please check your email for further details",
		"interview-analysis-details-label": "Details",
		"interview-analysis-error-label": "The analysis could not be loaded. Please try again.",
		"interview-analysis-heading-label": "Analysis",
		"interview-analysis-loading-label": "Loading analysis...",
		"interview-analysis-no-answers-label": "No answers have been analysed yet.",
		"interview-analysis-question-label": "Question",
		"interview-analysis-refresh-button-label": "Refresh",
		"interview-analysis-select-label": "Select an interview to see its analysis.",
		"interview-analysis-status-completed-label": "Completed",
		"interview-analysis-status-failed-label": "Failed",
		"interview-analysis-status-inprogress-label": "In progress",
		"interview-analysis-status-notanalysed-label": "Not analysed",
		"interview-analysis-type-personality-label": "Personality",
		"interview-analysis-type-pertinence-label": "Pertinence",
		"interview-analysis-type-sentiment-label": "Sentiment",
		"invite-accept-button-label": "Join",
		"invite-accept-button-progress-label": "Joining...",
		"invite-confirm-password-label": "Confirm Password",
		"invite-email-label": "Email:",
		"invite-first-name-label": "First Name",
		"invite-heading-label": "Join",
		"invite-invalid-label": "This invitation is no longer valid",
		"invite-last-name-label": "Last Name",
		"invite-mobile-label": "Mobile",
		"invite-password-label": "Password",
		"job-applier-apply-button-label": "Apply",
		"job-applier-cancel-button-label": "Cancel",
		"job-applier-dismiss-button-label": "Close",
		"job-applier-email-label": "Email",
		"job-applier-first-name-label": "First Name",
		"job-applier-heading-label": "Application Form",
		"job-applier-phone-label": "Mobile",
		"job-applier-success-label": "Application received, you will receive an email and SMS shortly for further information",
		"job-applier-surname-label": "Surname",
		"job-applier-trial-limit-label": "This job isn't accepting applications right now",
		"job-delete-label": "Delete",
		"job-description-generate-label": "Generate",
		"job-description-generate-progress-label": "Generating...",
		"job-description-trial-limit-label": "Your trial limit for this has been reached — we'll lift it once your account is approved",
		"job-detail-applicants-button-label": "View Applicants",
		"job-detail-base-tab-label": "Job Details",
		"job-detail-base-certifications-label": "Certifications or Education: ",
		"job-detail-base-certifications-placeholder": "Certifications or Education: ",
		"job-detail-base-company-label": "Company Name: ",
		"job-detail-base-company-placeholder": "Company Name",
		"job-detail-base-employment-status-label": "Employment Status: ",
		"job-detail-base-employment-status-placeholder": "Employment Status",
		"job-detail-base-location-label": "Location: ",
		"job-detail-base-location-placeholder": "Location",
		"job-detail-base-pay-label": "Pay: ",
		"job-detail-base-pay-rate-label": "Pay ($)",
		"job-detail-base-pay-rate-placeholder": "$Amount",
		"job-detail-base-pay-type-label": "Pay Type: ",
		"job-detail-base-pay-type-placeholder": "Pay Type",
		"job-detail-base-pay-visible-label": "Public",
		"job-detail-base-role-label": "Role: ",
		"job-detail-base-role-placeholder": "Role",
		"job-detail-base-short-desc-label": "Short Description: ",
		"job-detail-base-short-desc-placeholder": "Short Description",
		"job-detail-base-title-label": "Job Title: ",
		"job-detail-base-title-placeholder": "Job Title",
		"job-detail-base-type-label": "Employment Type: ",
		"job-detail-base-type-placeholder": "Employment Type",
		"job-detail-cancel-button-label": "Cancel",
		"job-detail-delete-button-label": "Delete",
		"job-detail-delete-cancel-label": "Cancel",
		"job-detail-delete-confirm-heading": "Warning!",
		"job-detail-delete-confirm-label": "Yes, I'm sure",
		"job-detail-delete-confirm-message": "Are you sure you want to delete this item?",
		"job-detail-description-tab-label": "Job Description",
		"job-detail-edit-button-label": "Edit",
		"job-detail-personality-tab-label": "Personality",
		"job-detail-questions-tab-label": "Interview Questions",
		"job-detail-role-tab-label": "Role Details",
		"job-detail-save-button-label": "Save",
		"job-detail-trial-limit-label": "Your trial limit for this has been reached — we'll lift it once your account is approved",
		"job-enrichment-add-label": "Add",
		"job-enrichment-add-progress-label": "Adding...",
		"job-enrichment-field-label": "",
		"job-enrichment-field-placeholder": "",
		"job-enrichment-individual-advantages-label": "Individual Advantages",
		"job-enrichment-opportunities-label": "Opportunities",
		"job-enrichment-prestige-label": "Prestige",
		"job-enrichment-responsibilities-label": "Responsibilities",
		"job-enrichment-security-label": "Security",
		"job-filter-apply-label": "Apply",
		"job-filter-cancel-label": "Cancel",
		"job-filter-company-label": "Company",
		"job-filter-company-placeholder": "Title",
		"job-filter-created-end-label": "End",
		"job-filter-created-end-placeholder": "End",
		"job-filter-created-label": "Created between:",
		"job-filter-created-to-label": "to",
		"job-filter-created-start-label": "Start",
		"job-filter-created-start-placeholder": "Start",
		"job-filter-heading-label": "Filter",
		"job-filter-published-end-label": "End",
		"job-filter-published-end-placeholder": "End",
		"job-filter-published-label": "Published between:",
		"job-filter-published-to-label": "to",
		"job-filter-published-start-label": "Start",
		"job-filter-published-start-placeholder": "Start",
		"job-filter-status-label": "Status",
		"job-filter-title-label": "Title",
		"job-filter-title-placeholder": "Title",
		"job-interview-question-label": "Question",
		"job-interview-question-empty-label": "(No questions set)",
		"job-interview-question-placeholder": "Question",
		"job-search-label": "Search",
		"job-search-placeholder": "Search",
		"job-view-label": "View",
		"jobs-applicants-label": "Applicants",
		"jobs-company-label": "Company",
		"jobs-created-label": "Created",
		"jobs-heading-label": "Jobs",
		"jobs-options-label": "",
		"jobs-published-label": "Published",
		"jobs-status-label": "Status",
		"jobs-title-label": "Title",
		"login-button-label": "Login",
		"login-button-progress-label": "Logging in...",
		"login-forgot-password-link-label": "Forgot Password?",
		"login-password-label": "Password",
		"login-password-placeholder": "Password",
		"login-register-link-label": "Register",
		"login-username-label": "Username",
		"login-username-placeholder": "Username",
		"main-menu-dashboard-label": "Dashboard",
		"main-menu-jobs-label": "Jobs",
		"main-menu-logout-label": "Logout",
		"main-menu-profile-label": "Profile",
		"main-menu-team-label": "Team",
		"message-dialog-dismiss-label-default": "Ok",
		"mfa-back-link-label": "Back",
		"mfa-heading-label": "Verification Code",
		"mfa-login-button-label": "Verify",
		"mfa-login-button-progress-label": "Logging in...",
		"personality-chart-value-label": "Trait",
		"personality-trait-range-label": "",
		"personality-trait-range-placeholder": "Minimum",
		"personality-trait-value-label": "",
		"register-button-label": "Register",
		"register-button-progress-label": "Registering...",
		"register-check-inbox-label": "We've sent a confirmation link to:",
		"register-company-label": "Company Name",
		"register-confirm-password-label": "Confirm Password",
		"register-email-label": "Email",
		"register-login-link-label": "Already registered?",
		"register-mobile-label": "Mobile",
		"register-password-label": "Password",
		"register-resend-button-label": "Resend Email",
		"register-resend-button-progress-label": "Sending...",
		"search-label": "Search",
		"search-placeholder": "Search",
		"team-error-email-registered-label": "That email already has a Schabu account",
		"team-error-trial-limit-prefix-label": "Your trial allows",
		"team-error-trial-limit-suffix-label": "invitations",
		"team-heading-label": "Team",
		"team-invitations-email-label": "Email",
		"team-invitations-expires-label": "Expires",
		"team-invitations-options-label": "",
		"team-invitations-revoke-label": "Revoke",
		"team-invitations-role-label": "Role",
		"team-invitations-status-label": "Status",
		"team-invite-button-label": "Invite",
		"team-invite-button-progress-label": "Inviting...",
		"team-invite-email-label": "Email",
		"team-invite-role-label": "Role",
		"team-not-allowed-label": "Only company admins can manage the team",
		"team-role-admin-label": "Admin",
		"team-role-member-label": "Member"
	}
}
